import script from "./skillsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./skillsSection.vue?vue&type=script&setup=true&lang=js"

import "./skillsSection.vue?vue&type=style&index=0&id=4d14f01c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d14f01c"]])

export default __exports__